module.exports = __webpack_public_path__ + "8f1df1142681c19a4b45d16a152d974b.svg";